module.exports = __webpack_public_path__ + "files/eeaa2d69d77d8b369a2543857bec53b4.png";